import { configureStore } from "@reduxjs/toolkit";
import { removeRefreshToken, removeToken } from "shared/plugins/http-service";
import { customerSlice } from "states/customer/customer.slice";
import { globalValueSlice } from "states/global-value/global-value.slice";
export const store = configureStore({
  reducer: {
    globalValue: globalValueSlice.reducer,
    customer: customerSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV === "development",
});
store.subscribe(() =>{
  let state = store.getState();
  if(!state.globalValue.isSignIn){
    removeToken();
    removeRefreshToken();
  }
})
// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
